
import { css } from 'lit';
export default css`
:root{
  --pc-wysiwyg-ul-carret-size:6px;
  --pc-wysiwyg-ul-carret-color:var(--purple-indigo-light);
  --pc-wysiwyg-table-font-color:var(--neutral-charcoal);
  --pc-wysiwyg-table-heading-font-color:var(--primary-white);
}

pc-wysiwyg,
.ck-content{
  display:block;
  color:inherit;
  color:var(--wysiwyg-font-color, inherit);
  font-size:var(--fs-body-mobile);
  line-height:var(--lh-body-mobile);
  font-family:var(--ff-body);
}

@media print{

pc-wysiwyg,
.ck-content{
    font-size:var(--fs-body);
    width:100%
}
  }

@media (min-width: 992px){

pc-wysiwyg,
.ck-content{
    font-size:var(--fs-body);
    line-height:var(--lh-body)
}
  }

pc-wysiwyg p, .ck-content p{
    margin-top:var(--spacing-4);
    margin-bottom:var(--spacing-4);
  }

pc-wysiwyg p.lead, .ck-content p.lead{
      margin-bottom:var(--spacing-8);
      color:var(--purple-indigo);
      font-weight:var(--fw-light);
      line-height:var(--lh-h4);
      font-family:var(--ff-display);
      font-size:var(--fs-h4);
    }

pc-wysiwyg p:empty, .ck-content p:empty{
      margin-top:0;
      margin-bottom:0;
    }

pc-wysiwyg .text-underline, .ck-content .text-underline{
    text-decoration:underline;
  }

pc-wysiwyg .text-xs, .ck-content .text-xs{
    font-size:var(--fs-xs);
  }

pc-wysiwyg .text-sm, .ck-content .text-sm{
    font-size:var(--fs-sm);
  }

pc-wysiwyg .text-base, .ck-content .text-base{
    font-size:var(--fs-base);
  }

pc-wysiwyg .text-lg, .ck-content .text-lg{
    font-size:var(--fs-lg);
  }

pc-wysiwyg .text-xl, .ck-content .text-xl{
    font-size:var(--fs-xl);
  }

pc-wysiwyg ul, .ck-content ul{
    list-style-type:none;
    margin-top:var(--spacing-4);
    margin-bottom:var(--spacing-4);
  }

pc-wysiwyg ul.indent, .ck-content ul.indent{
      margin-left:var(--spacing-4);
    }

pc-wysiwyg ul li, .ck-content ul li{
    position:relative;
    margin-top:var(--spacing-4);
    margin-bottom:var(--spacing-4);
    padding-left:var(--spacing-6);
  }

pc-wysiwyg ul li.trim-margin p, .ck-content ul li.trim-margin p{
      margin:0;
    }

pc-wysiwyg ol, .ck-content ol{
    margin-top:var(--spacing-4);
    margin-bottom:var(--spacing-4);
    padding-left:var(--spacing-6);
    list-style-type:decimal;
  }

pc-wysiwyg ol ol, .ck-content ol ol{
      list-style-type:lower-latin;
    }

pc-wysiwyg ol ol ol, .ck-content ol ol ol{
      list-style-type:lower-roman;
    }

pc-wysiwyg ol ol ol ol, .ck-content ol ol ol ol{
      list-style-type:upper-latin;
    }

pc-wysiwyg ol.indent,.ck-content ol.indent{
      margin-left:var(--spacing-4);
    }

pc-wysiwyg ol li, .ck-content ol li{
    margin-top:var(--spacing-4);
    margin-bottom:var(--spacing-4);
    padding-left:var(--spacing-1);
  }

pc-wysiwyg a, .ck-content a{
    --link-border-image:linear-gradient(
      transparent calc(100% - 2px),
      var(--purple-indigo) 2px
    );
    transition:background-size 0.3s;
    background-image:var(--link-border-image);
    background-size:0 100%;
    background-repeat:no-repeat;
    padding-bottom:2px;
    color:var(--purple-indigo);
  }

pc-wysiwyg em, .ck-content em{
    font-style:italic;
  }

pc-wysiwyg strong, .ck-content strong{
    font-weight:var(--fw-bold);
  }

pc-wysiwyg figure figcaption, .ck-content figure figcaption{
    margin-top:var(--spacing-2);
    color:var(--neutral-medium-gray);
    font-size:var(--fs-caption-mobile);
    line-height:var(--lh-caption-mobile);
  }

pc-wysiwyg .text-align-left, .ck-content .text-align-left{
    text-align:left;
  }

pc-wysiwyg .text-align-right, .ck-content .text-align-right{
    text-align:right;
  }

pc-wysiwyg .text-align-center, .ck-content .text-align-center{
    text-align:center;
  }

pc-wysiwyg .text-align-justify, .ck-content .text-align-justify{
    text-align:justify;
  }

pc-wysiwyg .align-left, .ck-content .align-left{
    float:left;
  }

pc-wysiwyg .align-right, .ck-content .align-right{
    float:right;
  }

pc-wysiwyg .media-oembed-content, .ck-content .media-oembed-content{
    aspect-ratio:16 / 9;
    height:100%;
    width:100%;
    border-radius:8px;
  }

pc-wysiwyg .align-center, .ck-content .align-center{
    display:table;
    margin-right:auto;
    margin-left:auto;
  }

pc-wysiwyg blockquote, .ck-content blockquote{
    border-left:2px solid var(--purple-indigo);
    padding-left:var(--spacing-4);
    font-family:var(--ff-body);
    font-size:var(--fs-body-mobile);
    font-weight:var(--fw-normal);
    line-height:var(--lh-body-mobile);
    color:var(--neutral-medium-gray);
  }

pc-wysiwyg .bold, .ck-content .bold{
    font-weight:500;
  }

pc-wysiwyg hr, .ck-content hr{
    border-color:var(--purple-medium-neutral);
    border-width:2px;
    margin:var(--spacing-4) 0;
  }

pc-wysiwyg .inter, .ck-content .inter{
    font-family:var(--ff-inter);
  }

pc-wysiwyg .display, .ck-content .display{
    font-family:var(--ff-display);
  }

pc-wysiwyg .body, .ck-content .body{
    font-family:var(--ff-body);
  }

pc-wysiwyg figure figcaption, .ck-content figure figcaption{
    font-size:var(--fs-caption);
    line-height:var(--lh-caption);
  }

pc-wysiwyg .align-left, .ck-content .align-left{
    margin-right:var(--spacing-6);
  }

pc-wysiwyg .align-right, .ck-content .align-right{
    margin-left:var(--spacing-6);
  }

pc-wysiwyg blockquote, .ck-content blockquote{
    padding-left:var(--spacing-6);
    font-size:var(--fs-body);
    line-height:var(--lh-body);
  }

pc-wysiwyg .media-oembed-content, .ck-content .media-oembed-content{
    max-width:560px;
    margin-right:auto;
    margin-left:auto;
  }

@media (min-width: 992px){
    pc-wysiwyg .media-oembed-content, .ck-content .media-oembed-content{
      max-width:692px;
    }
  }

pc-wysiwyg > :first-child,
pc-wysiwyg > :first-child li:first-child{
  margin-top:0;
}

pc-wysiwyg > :last-child,
pc-wysiwyg > :last-child li:last-child{
  margin-bottom:0;
}

pc-wysiwyg p{
  margin-top:var(--spacing-4);
  margin-bottom:var(--spacing-4);
}

pc-wysiwyg p:empty{
  margin-top:0;
  margin-bottom:0;
}

pc-wysiwyg p.lead{
  margin-bottom:var(--spacing-8);
  color:var(--purple-indigo);
  font-weight:var(--fw-light);
  font-size:var(--fs-h4);
  line-height:var(--lh-h4);
  font-family:var(--ff-display);
}

@media print{

pc-wysiwyg p.lead{
    font-size:14px;
    margin-bottom:var(--spacing-4)
}
  }

pc-wysiwyg ul{
  margin-top:var(--spacing-4);
  margin-bottom:var(--spacing-4);
}

@media print{

pc-wysiwyg ul{
    break-inside:avoid
}

    pc-wysiwyg ul > li:first-child,
    pc-wysiwyg ul:first-child li:first-child{
      margin-block:var(--spacing-0);
    }

    pc-wysiwyg ul > li:last-child{
      margin-bottom:var(--spacing-0);
    }
  }

pc-wysiwyg ul li{
  position:relative;
  margin-top:var(--spacing-4);
  margin-bottom:var(--spacing-4);
  padding-left:var(--spacing-6);
}

@media print{

pc-wysiwyg ul li{
    break-inside:avoid;
    page-break-inside:avoid;
    margin-top:var(--spacing-0);
    margin-bottom:var(--spacing-0)
}
  }

pc-wysiwyg ul li::before,
.ck-content ul li::before{
  display:inline-block;
  position:absolute;
  left:0;
  color:var(--purple-indigo);
  content:'-';
  font-size:var(--spacing-8);
  line-height:65%;
}

pc-wysiwyg a:hover,
.ck-content a:hover{
  background-size:100% 100%;
}

pc-wysiwyg figure,
pc-wysiwyg > div,
.ck-content figure,
.ck-content > div{
  margin-top:var(--spacing-4);
  margin-bottom:var(--spacing-4);
}

.ck-content figure[data-view-mode="width_100"]{
  width:100%;
}

.ck-content figure[data-view-mode="width_75"]{
  width:75%;
}

.ck-content figure[data-view-mode="width_50"]{
  width:50%;
}

.ck-content figure[data-view-mode="width_25"]{
  width:25%;
}

@media (min-width: 992px){
  pc-wysiwyg .media--width_100{
    width:100%;
  }
    pc-wysiwyg .media--width_100 img{
      width:100%;
    }

  pc-wysiwyg .media--width_75{
    width:75%;
  }
    pc-wysiwyg .media--width_75 img{
      width:100%;
    }

  pc-wysiwyg .media--width_50{
    width:50%;
  }
    pc-wysiwyg .media--width_50 img{
      width:100%;
    }

  pc-wysiwyg .media--width_25{
    width:25%;
  }
    pc-wysiwyg .media--width_25 img{
      width:100%;
    }
}

pc-wysiwyg h1,
  pc-wysiwyg .h1,
  pc-wysiwyg h2,
  pc-wysiwyg .h2,
  pc-wysiwyg h3,
  pc-wysiwyg .h3,
  pc-wysiwyg h4,
  pc-wysiwyg .h4,
  pc-wysiwyg h5,
  pc-wysiwyg .h5,
  pc-wysiwyg h6,
  pc-wysiwyg .h6,
  .ck-content h1,
  .ck-content .h1,
  .ck-content h2,
  .ck-content .h2,
  .ck-content h3,
  .ck-content .h3,
  .ck-content h4,
  .ck-content .h4,
  .ck-content h5,
  .ck-content .h5,
  .ck-content h6,
  .ck-content .h6{
    font-weight:var(--fw-bold);
  }

pc-wysiwyg h1,
  pc-wysiwyg .h1,
  pc-wysiwyg .h2,
  pc-wysiwyg h2,
  pc-wysiwyg .h4,
  pc-wysiwyg h4,
  pc-wysiwyg .h6,
  pc-wysiwyg h6,
  .ck-content h1,
  .ck-content .h1,
  .ck-content .h2,
  .ck-content h2,
  .ck-content .h4,
  .ck-content h4,
  .ck-content .h6,
  .ck-content h6{
    font-family:var(--ff-display);
  }

pc-wysiwyg h3,
  pc-wysiwyg .h3,
  pc-wysiwyg h5,
  pc-wysiwyg .h5,
  .ck-content h3,
  .ck-content .h3,
  .ck-content h5,
  .ck-content .h5{
    font-family:var(--ff-inter);
  }

pc-wysiwyg h1,
.ck-content h1{
  font-weight:var(--fw-light);
  margin-bottom:var(--spacing-4);
  font-size:var(--fs-h1-mobile);
  line-height:var(--lh-h1);
}

@media (min-width: 992px){

pc-wysiwyg h1,
.ck-content h1{
    font-size:var(--fs-h1)
}
  }

pc-wysiwyg h2,
.ck-content h2{
  font-weight:var(--fw-light);
  margin-bottom:var(--spacing-4);
  font-size:var(--fs-h2-mobile);
  line-height:var(--lh-h2);
}

@media (min-width: 992px){

pc-wysiwyg h2,
.ck-content h2{
    font-size:var(--fs-h2)
}
  }

pc-wysiwyg h3,
.ck-content h3{
  font-weight:var(--fw-normal);
  margin-bottom:var(--spacing-4);
  font-size:var(--fs-h3-mobile);
  line-height:var(--lh-h3);
}

@media (min-width: 992px){

pc-wysiwyg h3,
.ck-content h3{
    font-size:var(--fs-h3)
}
  }

pc-wysiwyg h4,
.ck-content h4{
  font-weight:var(--fw-light);
  margin-bottom:var(--spacing-4);
  font-size:var(--fs-h4-mobile);
  line-height:var(--lh-h4);
}

@media (min-width: 992px){

pc-wysiwyg h4,
.ck-content h4{
    font-size:var(--fs-h4)
}
  }

pc-wysiwyg h5,
.ck-content h5{
  font-weight:var(--fw-normal);
  margin-bottom:var(--spacing-4);
  font-size:var(--fs-h5-mobile);
  line-height:var(--lh-h5);
}

@media (min-width: 992px){

pc-wysiwyg h5,
.ck-content h5{
    font-size:var(--fs-h5)
}
  }

@media print{

pc-wysiwyg h5,
.ck-content h5{
    color:var(--wysiwyg-font-color-h5);
    font-weight:var(--wysiwyg-font-weight-h5);
    line-height:var(--wysiwyg-font-height-h5)
}
  }

pc-wysiwyg h6,
.ck-content h6{
  font-weight:var(--fw-normal);
  margin-bottom:var(--spacing-4);
  font-size:var(--fs-h6-mobile);
  line-height:var(--lh-h6);
}

@media (min-width: 992px){

pc-wysiwyg h6,
.ck-content h6{
    font-size:var(--fs-h6)
}
  }

pc-wysiwyg .h2,
.ck-content .h2{
  font-weight:var(--fw-light);
  margin-bottom:var(--spacing-4);
  font-size:var(--fs-h2-mobile);
  line-height:var(--lh-h2);
}

@media (min-width: 992px){

pc-wysiwyg .h2,
.ck-content .h2{
    font-size:var(--fs-h2)
}
  }

pc-wysiwyg .h3,
.ck-content .h3{
  font-weight:var(--fw-normal);
  margin-bottom:var(--spacing-4);
  font-size:var(--fs-h3-mobile);
  line-height:var(--lh-h3);
}

@media (min-width: 992px){

pc-wysiwyg .h3,
.ck-content .h3{
    font-size:var(--fs-h3)
}
  }

pc-wysiwyg .h4,
.ck-content .h4{
  font-weight:var(--fw-light);
  margin-bottom:var(--spacing-4);
  font-size:var(--fs-h4-mobile);
  line-height:var(--lh-h4);
}

@media (min-width: 992px){

pc-wysiwyg .h4,
.ck-content .h4{
    font-size:var(--fs-h4)
}
  }

pc-wysiwyg .h5,
.ck-content .h5{
  font-weight:var(--fw-normal);
  margin-bottom:var(--spacing-4);
  font-size:var(--fs-h5-mobile);
  line-height:var(--lh-h5);
}

@media (min-width: 992px){

pc-wysiwyg .h5,
.ck-content .h5{
    font-size:var(--fs-h5)
}
  }

pc-wysiwyg .h6,
.ck-content .h6{
  font-weight:var(--fw-normal);
  margin-bottom:var(--spacing-4);
  font-size:var(--fs-h6-mobile);
  line-height:var(--lh-h6);
}

@media (min-width: 992px){

pc-wysiwyg .h6,
.ck-content .h6{
    font-size:var(--fs-h6)
}
  }

pc-wysiwyg table, .ck-content table{
    color:var(--neutral-charcoal);
    color:var(--pc-wysiwyg-table-font-color);
    width:100%;
    min-width:600px;
    table-layout:fixed;
    height:100%;
    border:1px solid var(--neutral-medium-gray);
    font-size:var(--fs-body-mobile);
  }

@media (min-width: 992px){

pc-wysiwyg table, .ck-content table{
      font-size:var(--fs-body)
  }
    }

pc-wysiwyg table tbody, .ck-content table tbody{
      width:100%;
    }

pc-wysiwyg table thead tr th,
    pc-wysiwyg table thead tr th a,
    .ck-content table thead tr th,
    .ck-content table thead tr th a{
      background-color:var(--primary-eggplant);
      color:var(--primary-white);
      color:var(--pc-wysiwyg-table-heading-font-color);
      border-bottom-color:var(--primary-eggplant);
    }

pc-wysiwyg table thead tr th:not(:last-of-type), .ck-content table thead tr th:not(:last-of-type){
      border-right-color:var(--purple-indigo);
    }

pc-wysiwyg table tbody tr:nth-child(even), .ck-content table tbody tr:nth-child(even){
      background-color:var(--purple-medium-neutral);
    }

pc-wysiwyg table th,
    pc-wysiwyg table td,
    .ck-content table th,
    .ck-content table td{
      border:1px solid var(--neutral-medium-gray);
      border-collapse:collapse;
      padding:var(--spacing-3) var(--spacing-4);
      min-width:20ch;
      vertical-align:top;
      overflow:auto;
    }

pc-wysiwyg table tbody th,
      pc-wysiwyg table tbody td,
      .ck-content table tbody th,
      .ck-content table tbody td{
        font-size:var(--fs-body-mobile);
      }

@media (min-width: 992px){

pc-wysiwyg table tbody th,
      pc-wysiwyg table tbody td,
      .ck-content table tbody th,
      .ck-content table tbody td{
          font-size:var(--fs-body)
      }
        }

pc-wysiwyg table tbody th sup, pc-wysiwyg table tbody td sup, .ck-content table tbody th sup, .ck-content table tbody td sup{
          font-size:60% !important;
        }

pc-wysiwyg table tbody th sub, pc-wysiwyg table tbody td sub, .ck-content table tbody th sub, .ck-content table tbody td sub{
          font-size:60% !important;
        }

pc-wysiwyg table th, .ck-content table th{
      text-align:left;
    }

pc-wysiwyg table ::-webkit-scrollbar, .ck-content table ::-webkit-scrollbar{
      max-width:var(--spacing-01);
      max-height:var(--spacing-01);
    }

pc-wysiwyg table ::-webkit-scrollbar-thumb, .ck-content table ::-webkit-scrollbar-thumb{
      background-color:var(--color-neutral-light);
      border-radius:var(--spacing-03);
    }

pc-wysiwyg table sup, .ck-content table sup{
      vertical-align:super;
    }

pc-wysiwyg table sub, .ck-content table sub{
      vertical-align:sub;
    }

pc-wysiwyg table p, .ck-content table p{
      margin:0px;
    }

pc-wysiwyg table.clean-table, .ck-content table.clean-table{
    border:0;
  }

pc-wysiwyg table.clean-table thead tr th,
    pc-wysiwyg table.clean-table thead tr th a,
    .ck-content table.clean-table thead tr th,
    .ck-content table.clean-table thead tr th a{
      border:0;
      background-color:transparent;
      color:var(--neutral-charcoal);
      color:var(--pc-wysiwyg-table-font-color);
    }

pc-wysiwyg table.clean-table th,
    pc-wysiwyg table.clean-table td,
    .ck-content table.clean-table th,
    .ck-content table.clean-table td{
      border:0;
    }

pc-wysiwyg table.clean-table tbody tr, .ck-content table.clean-table tbody tr{
      background-color:transparent;
    }

pc-wysiwyg table.bordered-table thead tr th,
    pc-wysiwyg table.bordered-table thead tr th a,
    .ck-content table.bordered-table thead tr th,
    .ck-content table.bordered-table thead tr th a{
      background-color:transparent;
      color:var(--neutral-charcoal);
      color:var(--pc-wysiwyg-table-font-color);
    }

pc-wysiwyg table.bordered-table tbody tr, .ck-content table.bordered-table tbody tr{
      background-color:transparent;
    }

pc-wysiwyg[is-collapsable],
.ck-content[is-collapsable]{
  display:flex;
  flex-direction:column;
  align-items:flex-start;
}

pc-wysiwyg[is-collapsable] .content, .ck-content[is-collapsable] .content{
    position:relative;
    margin-bottom:0;
  }

pc-wysiwyg[is-collapsable] .content p:first-child, .ck-content[is-collapsable] .content p:first-child{
      margin-top:0;
    }

pc-wysiwyg[is-collapsable] .dropdown-trigger, .ck-content[is-collapsable] .dropdown-trigger{
    display:inline-flex;
    align-items:center;
    gap:var(--spacing-2);
    transition:all 300ms ease-in;
    border:0;
    background:transparent;
    padding:0;
    color:var(--purple-indigo);
    font-weight:var(--fw-medium);
    font-size:var(--fs-base);
    font-family:var(--ff-body);
  }

pc-wysiwyg[is-collapsable] .dropdown-trigger:hover, .ck-content[is-collapsable] .dropdown-trigger:hover{
      cursor:pointer;
      color:var(--primary-eggplant);
    }

pc-wysiwyg[is-collapsable] .dropdown-trigger[aria-expanded='true'], .ck-content[is-collapsable] .dropdown-trigger[aria-expanded='true']{
      margin-top:var(--spacing-4);
    }

@media print{

pc-wysiwyg[is-collapsable] .dropdown-trigger, .ck-content[is-collapsable] .dropdown-trigger{
      display:none
  }
    }

pc-wysiwyg[is-collapsable] .collapsable-panel, .ck-content[is-collapsable] .collapsable-panel{
    height:auto;
    margin-top:0;
    margin-bottom:0;
  }

pc-wysiwyg[is-collapsable] .collapsable-panel[aria-hidden], .ck-content[is-collapsable] .collapsable-panel[aria-hidden]{
      transition:all 300ms ease;
      overflow:hidden;
    }

pc-wysiwyg[is-collapsable] .collapsable-panel[aria-hidden='true'], .ck-content[is-collapsable] .collapsable-panel[aria-hidden='true']{
      height:0;
    }

@media print{

pc-wysiwyg[is-collapsable] .collapsable-panel[aria-hidden='true'], .ck-content[is-collapsable] .collapsable-panel[aria-hidden='true']{
        height:auto
    }
      }

pc-wysiwyg[is-collapsable] .collapsable-panel[aria-hidden='false'], .ck-content[is-collapsable] .collapsable-panel[aria-hidden='false']{
      height:var(--wysiwyg-expanded-height);
    }

pc-wysiwyg[is-collapsable] .collapsable-panel *:first-child, .ck-content[is-collapsable] .collapsable-panel *:first-child{
      margin-top:0;
    }

pc-wysiwyg[is-collapsable] .collapsable-panel *:last-child, .ck-content[is-collapsable] .collapsable-panel *:last-child{
      margin-bottom:0;
    }

body #drupal-off-canvas [data-drupal-ck-style-fence] .ck-content ul,.ck-content ul{
    list-style-type:none;
  }

body #drupal-off-canvas [data-drupal-ck-style-fence] .ck-content ul li, .ck-content ul li{
      padding-left:var(--spacing-4) !important;
    }

body #drupal-off-canvas [data-drupal-ck-style-fence] .ck-content ul ul, .ck-content ul ul{
      list-style-type:none;
    }

body #drupal-off-canvas [data-drupal-ck-style-fence] .ck-content ul ul li, .ck-content ul ul li{
        padding-left:var(--spacing-4) !important;
      }

body #drupal-off-canvas [data-drupal-ck-style-fence] .ck-content ul.indent,body #drupal-off-canvas [data-drupal-ck-style-fence] .ck-content ol.indent,.ck-content ul.indent,.ck-content ol.indent{
      margin-left:var(--spacing-4);
    }
`;